import { styled } from '@mui/material'

export const Root = styled('div', {
  shouldForwardProp: (propName: PropertyKey) => propName !== 'isBlock',
})<{ isBlock?: boolean }>(({ theme, isBlock }) => ({
  alignItems: 'center',
  display: 'flex',
  // Take the remaining width in the flex header bar and allow ellipsis.
  flex: 1,
  minWidth: 0,

  ...(isBlock
    ? {
        [theme.breakpoints.down('sm')]: {
          '&&': {
            display: 'block',
          },
        },
      }
    : {}),
}))
